import Page from "webPage/Page";
import Track from "webPage/Track";
import {handleScrollingSection} from "util/scrolling-section.js";
import TestimonialSliderModal from "../modal/TestimonialSliderModal.js";

Page.register('home', () => {
    handleScrollingSection($(".js-infinite-scroll"), 0);

    let $slider = $('.js-slider');

    if ($slider.length > 0) {
        $slider.each(function (index, el) {
            new Track($(el), {
                classes: {
                    block: "slider",
                },
                navigateItemCount: 3
            });
        });
    }

    $('body').on('click', '.js-book-event', function(){
        $('.js-modal-book-event').addClass('modal--active');
        $('body').addClass('modal-active');
        return false;
    }).on('click', '.js-modal-book-event .js-close-modal', function(){
        $('.js-modal-book-event').removeClass('modal--active');
        $('body').removeClass('modal-active');
        return false;
    }).on('click', '.js-read-testimonial', function(){
        let clone = $(this).closest('.js-testimonial-card').clone();
        let modal = new TestimonialSliderModal(clone);
        modal.show();

        return false;
    });
});
